module.exports = __webpack_public_path__ + "img/Profile Icon - charcoal.c6d91211.svg";